import styled from 'styled-components';

type Props = {
  isKor: boolean;
};

export const EmailVerificationTitle = ({ isKor }: Props) => {
  return (
    <TitleWrapper>
      <Title>
        {isKor ? '문의하기 이용을 위해' : 'Please verify your E-mail'}
        <br />
        {isKor ? '이메일 인증을 해주세요.' : 'to send Inquiry.'}
      </Title>
      <SubTitle>
        {isKor
          ? '답변이 도착하면 고객님의 이메일로 알림이 발송됩니다. 최초 1회만 인증하면 됩니다.'
          : 'An answer notification will be sent to your email. You only need to verify once.'}
      </SubTitle>
    </TitleWrapper>
  );
};

const TitleWrapper = styled.p`
  text-align: left;
  margin-top: 20px;
`;

const Title = styled.strong`
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.6px;
`;

const SubTitle = styled.small`
  display: block;
  margin-top: 8px;
  color: #80848a;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
